export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contact');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section
      id="home"
      className="relative min-h-screen flex items-center justify-center overflow-hidden"
    >
      <div
        className="absolute inset-0 bg-cover bg-center"
        style={{
          backgroundImage: `url('https://public.readdy.ai/ai/img_res/80203fe5231ff14a3f13daabd3c2a15b.jpg')`,
        }}
      />
      <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 lg:px-8 w-full">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          <div className="text-left">
            <div className="flex items-center space-x-2 mb-6">
              <div className="flex -space-x-2">
                <div className="w-10 h-10 rounded-full bg-teal-500 border-2 border-white"></div>
                <div className="w-10 h-10 rounded-full bg-emerald-500 border-2 border-white"></div>
                <div className="w-10 h-10 rounded-full bg-cyan-500 border-2 border-white"></div>
              </div>
              <span className="text-white text-sm font-medium">500+ 외국계 취업 성공</span>
            </div>

            <h1 className="text-6xl lg:text-7xl font-bold text-white mb-4">
              외국계 커리어의 시작
            </h1>
            <p className="text-4xl lg:text-5xl font-light text-white/90 mb-8">
              당신의 글로벌 여정을 함께합니다
            </p>

            <button
              onClick={scrollToContact}
              className="group inline-flex items-center space-x-3 bg-white text-gray-900 px-8 py-4 rounded-full font-medium hover:bg-gray-100 transition-all duration-300 hover:shadow-xl whitespace-nowrap cursor-pointer"
            >
              <span>무료 상담 시작하기</span>
              <i className="ri-arrow-right-line text-xl group-hover:translate-x-1 transition-transform"></i>
            </button>
          </div>

          <div className="flex items-end justify-end">
            <div className="bg-white/10 backdrop-blur-sm p-8 rounded-2xl border border-white/20 max-w-md">
              <p className="text-white text-lg leading-relaxed">
                실무 경험을 바탕으로 한 실질적인 가이드와 1:1 맞춤 컨설팅으로 당신의 커리어 목표를 실현하세요
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
